<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12 sm12 lg12>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Utenti</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="tableSearch"
              append-icon="mdi-table-search"
              label="Cerca..."
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="tableData"
              :options.sync="options"
              :loading="loading"
              :search="tableSearch"
              class="elevation-1"
              :footer-props="{
                'items-per-page-options': [10, 15, 20, 30, 50]
              }"
              :items-per-page="15"
            >
              <template v-slot:top></template>
              <template v-slot:item.status_name="{ item }">
                <v-chip :color="getStatusColor(item.is_active)" dark>{{ item.status_name }}</v-chip>
              </template>
              <template v-slot:item.date_created="{ item }">
                <td>{{item.date_created | formatDateSmall }}</td>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="$router.push({ path: 'users/' + item.id, params: { userId: item.id } })"
                >mdi-square-edit-outline</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import apiService from '@/services'

export default {
  watch: {
    options: {
      handler () {
        //this.getUsersFromApi()
      },
      deep: true
    },
    dialog (val) {
      val || this.closeModal()
    }
  },
  data () {
    return {
      // Riicerca nella tabella
      tableSearch: '',
      // Modale
      dialog: false,
      // Crud Npo
      editedIndex: -1,
      editedNpo: {
        name: '',
        status: '',
        zipCode: '',
        vat: '',
        type: '',
        province: '',
        city: '',
        fiscalCode: '',
        address: '',
        legalRep: ''
      },
      defaultNpo: {
        name: '',
        status: '',
        zipCode: '',
        vat: '',
        type: '',
        province: '',
        city: '',
        fiscalCode: '',
        address: '',
        legalRep: ''
      },
      // Tabella Npo
      tableHeaders: [
        {
          text: 'First name',
          align: 'left',
          sortable: true,
          value: 'first_name'
        },
        {
          text: 'Last name',
          align: 'left',
          sortable: true,
          value: 'last_name'
        },
        { text: 'Email/Username', value: 'username', sortable: false },
        { text: 'Status', value: 'status_name', sortable: false },
        { text: 'Merchant/Client', value: 'entity', sortable: false },
        { text: 'Role', value: 'role', sortable: false },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      options: {},
      totalData: 0,
      tableData: [],
      loading: true
    }
  },

  // Titolo modale
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuova Npo' : 'Modifica Npo'
    }
  },

  mounted () {
    this.getUsersFromApi()
  },

  methods: {
    // GET degli utenti
    getUsersFromApi () {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.sortDesc = sortDesc[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage
      apiService
        .getUsers(filter)
        .then((response) => {
          const data = response
          data.map(user => {
            if (user.clients.length > 0 && user.clients[0].name !== null) {
              // User is client
              user.entity = user.clients[0].name
            }
            if (user.merchants.length > 0 && user.merchants[0].name !== null) {
              user.entity = user.merchants[0].name
              user.role = 'merchant'
            }
          })
          setTimeout(() => {
            this.tableData = data
            this.totalData = data.length
            this.loading = false
          }, 800)
        })
        .catch((data) => {
          console.log(data)
        })
    },

    editUser (user) {
      console.log(user)
      this.editedIndex = this.tableData.indexOf(user)
      this.editedNpo = Object.assign({}, user)
      this.dialog = true
    },

    deleteUser (user) {
      // const index = this.tableData.indexOf(npo)
      confirm('Sei sicuro di voler cancellare questo utente?') &&
        apiService.deleteUser(user).then((data) => {
          this.getUsersFromApi()
        }) // To Do documentarsi sul metodo
    },

    closeModal () {
      this.dialog = false
      setTimeout(() => {
        // Reset Npo vuota
        this.editedNpo = Object.assign({}, this.defaultNpo)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      console.log(this.editedIndex)
      if (this.editedIndex > -1) {
        Object.assign(this.tableData[this.editedIndex], this.editedNpo)
        apiService.editNpo(this.editedNpo).then((data) => {
          // To do snackbar
        })
      } else {
        apiService.newNpo(this.editedNpo).then((data) => {
          // To do snackbar
          this.tableData.push(this.editedNpo)
        })
      }
      // Aggiungere modifica a editedindex =  -1?
      this.closeModal()
    },

    getStatusColor (staus) {
      if (staus === true) return 'green'
      else if (staus === false) return 'red'
      else return 'gray'
    }
  }
}
</script>
